export default "__VITE_ASSET__XjWYkGoR__ 640w, __VITE_ASSET__B$HIb4pa__ 1024w, __VITE_ASSET__KLuvtSMO__ 1280w";